module.exports = __webpack_public_path__ + "static/img/price_picture.3ba9c4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price_picture.png
// module id = b1CR
// module chunks = 1